import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    barColor: 'rgba(0, 54, 95, .8), rgba(0, 54, 95, .8)',
    barImage: "https://s3.amazonaws.com/descargas.econnectpro.mx/barra.png",
    drawer: null,
    id_cliente: 0,
    diario: "",
    current_url: 0,
    datetime: 0,
    avatar: undefined,
    embarques_trafico: [],
    transportes_trafico: [],
    alertas_trafico: [],
    trafico: false,
    costing: false,
    emanifiesto: false,
    sa31:false,
    sa24:false,
    carta_porte: false,
    cambio_cliente: false,
    ultimo_y:"",
    ultimo_m:"",
    files: [],
    embarques_trafico: [{ id: 1, text: '...', done: true },
    { id: 2, text: '...', done: false }]
  },
  mutations: {
    SET_BAR_IMAGE(state, payload) {
      state.barImage = payload
    },
    SET_DRAWER(state, payload) {
      state.drawer = payload
    },
    SET_SCRIM(state, payload) {
      state.barColor = payload
    },
    updateFiles(state, files) {
      state.files = files
    }
  },
  actions: {

  },
})
